import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import {  GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import {  Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import {  MenuFuncionService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, SearchTipoMovimientoRequest } from '../../../../src/app/shared/model';
import { TipoMovimientoService } from '../../../../src/app/shared/services/tipo-movimiento.service';
import { DatePipe } from '@angular/common';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-tipo-movimiento-list',
  templateUrl: './tipo-movimiento-list.component.html',
  styleUrls: ['./tipo-movimiento-list.component.scss']
})
export class TipoMovimientoListComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;

  canEdit: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canRecurrente: boolean = false;

  isRosbaco: boolean = false;

  categoriaList: any[];
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private service: TipoMovimientoService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.TIPO_MOVIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.TIPO_MOVIMIENTO_LIST);
          if (this.canView) {
            this.loadView();
          } 
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      } 
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.getCategorias();

    this.setQueryParams();

    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.menuService.checkMenu(MenuFuncionCodes.MOVIMIENTO_RECURRENTES).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canRecurrente = true;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Nombre': [null],
      'Signo': [null],
      'VerSoloRecurrentes': [false],
      'VerSoloActivos': [false],
    });
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Tipo);
    
    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "Signo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Signo;
    else
      this.query.addParams("Signo",this.searchForm.value.Signo);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloRecurrentes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloRecurrentes.toString();
    else
      this.query.addParams("VerSoloRecurrentes",this.searchForm.value.VerSoloRecurrentes.toString());

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.searchForm.value.VerSoloActivos.toString());
  }

  getCategorias() {
    this.categoriaList = [
      { Id: -1, Nombre: "Ver solo deudas" },
      { Id: 1, Nombre: "Ver solo pagos" }
    ];
  }

  add() {
    if (this.canAdd) {
      this.router.navigate(['tipo-movimiento-edit', 0]);
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para crear un item", "Error");
    }
  }

  edit(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }
    
    this.router.navigate(['tipo-movimiento-edit', item.Id]);
  }

  onExport() {
    var search = new SearchTipoMovimientoRequest(null, null, null, "", null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "TiposMovimiento_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
